import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToSection } from '../utils/navigation';
import { logger } from '../utils/logger';

const ScrollToSection: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          // 統一されたナビゲーション処理を使用
          setTimeout(() => {
            logger.navigation(`Cross-page navigation to ${location.hash}`);
            scrollToSection(location.hash);
          }, 100);
        } else {
          logger.warn(`Element not found for hash: ${location.hash}`);
        }
      }, 300);
    } else if (location.pathname === '/') {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
};

export default ScrollToSection;